export const SDX_IFRAME_HEIGHT_PADDING = 31;
